import script from "./SignupPage.vue?vue&type=script&setup=true&lang=js"
export * from "./SignupPage.vue?vue&type=script&setup=true&lang=js"

import "./SignupPage.vue?vue&type=style&index=0&id=c6d23876&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c6d23876"]])

export default __exports__